/* ============================================================
   CIRCLE OF DESIRE - theme behaviour
   Cart runs on Shopify's AJAX Cart API; everything degrades to
   a normal /cart page if fetch fails.
   ============================================================ */
(function () {
  "use strict";

  var CFG = window.COD || {};
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var routes = CFG.routes || {};
  var money_format = CFG.moneyFormat || "&euro;{{amount_with_comma_separator}}";

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var fmt = format || money_format;
    var value = "";
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var num = (cents || 0) / 100;

    function thousands(n, precision, thousapart, decimal) {
      precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
      thousapart = thousapart == null ? "," : thousapart;
      decimal = decimal == null ? "." : decimal;
      var parts = n.toFixed(precision);
      parts = precision ? parts.split(".") : [parts];
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousapart);
      var centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }

    switch (fmt.match(placeholder) ? fmt.match(placeholder)[1] : "") {
      case "amount": value = thousands(num, 2); break;
      case "amount_no_decimals": value = thousands(num, 0); break;
      case "amount_with_comma_separator": value = thousands(num, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = thousands(num, 0, ".", ","); break;
      case "amount_with_apostrophe_separator": value = thousands(num, 2, "'", "."); break;
      case "amount_with_space_separator": value = thousands(num, 2, " ", ","); break;
      case "amount_no_decimals_with_space_separator": value = thousands(num, 0, " ", ""); break;
      default: value = thousands(num, 2);
    }
    return fmt.replace(placeholder, value);
  }
  window.CODformatMoney = formatMoney;

  /* ---------- theme toggle ---------- */
  var themeBtn = document.getElementById("themeBtn");
  if (themeBtn) {
    themeBtn.addEventListener("click", function () {
      var cur = document.documentElement.getAttribute("data-theme");
      var next = cur === "dark" ? "light" : "dark";
      document.documentElement.setAttribute("data-theme", next);
      try { localStorage.setItem("cod-theme", next); } catch (e) {}
    });
  }

  /* ---------- mobile menu ---------- */
  var sheet = document.getElementById("msheet");
  var burger = document.getElementById("burger");
  if (sheet && burger) {
    burger.addEventListener("click", function () { sheet.classList.add("on"); });
    var mc = document.getElementById("msheetClose");
    if (mc) mc.addEventListener("click", function () { sheet.classList.remove("on"); });
    sheet.querySelectorAll("nav a").forEach(function (a) {
      a.addEventListener("click", function () { sheet.classList.remove("on"); });
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById("drawer");
  var scrim = document.getElementById("scrim");
  var dBody = document.getElementById("drawerBody");
  var countEl = document.getElementById("cartCount");
  var subEl = document.getElementById("subtotal");

  function openCart() { if (drawer) { drawer.classList.add("on"); scrim.classList.add("on"); } }
  function closeCart() { if (drawer) { drawer.classList.remove("on"); scrim.classList.remove("on"); } }

  var cartBtn = document.getElementById("cartBtn");
  if (cartBtn) {
    cartBtn.addEventListener("click", function (e) {
      if (!drawer) return;            /* no drawer -> follow the link to /cart */
      e.preventDefault();
      getCart().then(renderCart).then(openCart);
    });
  }
  if (scrim) scrim.addEventListener("click", closeCart);
  var cartClose = document.getElementById("cartClose");
  if (cartClose) cartClose.addEventListener("click", closeCart);

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    closeCart();
    if (sheet) sheet.classList.remove("on");
  });

  function getCart() {
    return fetch(routes.cart_url ? routes.cart_url + ".js" : "/cart.js", {
      headers: { "Accept": "application/json" }
    }).then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    if (!dBody) return cart;
    if (!cart.items || !cart.items.length) {
      dBody.innerHTML = '<p class="drawer-empty">Nothing here yet.</p>';
    } else {
      dBody.innerHTML = cart.items.map(function (i) {
        var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : "";
        return '<div class="line-item" data-key="' + i.key + '">' +
          '<img src="' + img + '" alt="" width="68" height="68">' +
          '<div><div class="t">' + i.product_title + "</div>" +
          (i.variant_title && i.variant_title !== "Default Title"
            ? '<div class="v">' + i.variant_title + "</div>" : "") +
          '<div class="p">' + i.quantity + " &times; " + formatMoney(i.final_price) + "</div>" +
          '<div class="qty"><button data-step="-1" aria-label="Decrease">&minus;</button>' +
          "<span>" + i.quantity + "</span>" +
          '<button data-step="1" aria-label="Increase">+</button></div>' +
          '<button class="rm" data-step="0">Remove</button>' +
          "</div></div>";
      }).join("");
    }
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.classList.toggle("on", cart.item_count > 0);
    }
    if (subEl) subEl.textContent = formatMoney(cart.total_price);
    return cart;
  }

  function changeLine(key, qty) {
    return fetch(routes.cart_change_url ? routes.cart_change_url + ".js" : "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  if (dBody) {
    dBody.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-step]");
      if (!b) return;
      var row = b.closest(".line-item");
      var key = row.getAttribute("data-key");
      var step = +b.getAttribute("data-step");
      var cur = +row.querySelector(".qty span").textContent;
      changeLine(key, step === 0 ? 0 : Math.max(0, cur + step));
    });
  }

  function addToCart(id, qty) {
    if (!id) return Promise.reject();
    return fetch(routes.cart_add_url ? routes.cart_add_url + ".js" : "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    }).then(function () {
      return getCart().then(renderCart);
    }).then(function () {
      if (drawer) openCart();
    });
  }
  window.CODaddToCart = addToCart;

  /* ---------- quick add from product cards ---------- */
  document.addEventListener("click", function (e) {
    var q = e.target.closest("[data-quick-add]");
    if (!q) return;
    e.preventDefault();
    var id = q.getAttribute("data-quick-add");
    if (!id) { window.location.href = q.getAttribute("href") || "#"; return; }
    q.setAttribute("disabled", "");
    addToCart(id, 1).catch(function () {}).finally(function () { q.removeAttribute("disabled"); });
  });

  /* ---------- PDP: variants + crossfade gallery ---------- */
  var pdp = document.getElementById("pdp");
  if (pdp) initProduct(pdp);

  function initProduct(root) {
    var dataEl = root.querySelector("#pdp-data");
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var priceEl = root.querySelector("#pdpPrice");
    var atc = root.querySelector("#atc");
    var hiddenId = root.querySelector("#pf-id");
    var optGroups = root.querySelectorAll("[data-option-index]");
    var selected = {};

    optGroups.forEach(function (g) {
      var idx = +g.getAttribute("data-option-index");
      var on = g.querySelector(".size.on") || g.querySelector(".size:not([disabled])");
      if (on) selected[idx] = on.getAttribute("data-value");
    });

    function currentVariant() {
      if (!product) return null;
      return product.variants.filter(function (v) {
        return v.options.every(function (opt, i) {
          return selected[i + 1] == null || selected[i + 1] === opt;
        });
      })[0] || null;
    }

    function refresh() {
      var v = currentVariant();
      if (hiddenId && v) hiddenId.value = v.id;
      if (v && priceEl) {
        priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price
          ? "<s>" + formatMoney(v.compare_at_price) + "</s> " : "") + formatMoney(v.price);
      }
      if (atc) {
        if (!v) { atc.textContent = "Unavailable"; atc.setAttribute("aria-disabled", "true"); atc.dataset.variant = ""; }
        else if (!v.available) { atc.textContent = "Sold out"; atc.setAttribute("aria-disabled", "true"); atc.dataset.variant = String(v.id); }
        else { atc.textContent = "Add to cart"; atc.removeAttribute("aria-disabled"); atc.dataset.variant = String(v.id); }
      }
      /* mark option values that can't combine into anything available */
      optGroups.forEach(function (g) {
        var idx = +g.getAttribute("data-option-index");
        g.querySelectorAll(".size").forEach(function (btn) {
          var val = btn.getAttribute("data-value");
          var trial = Object.assign({}, selected); trial[idx] = val;
          var ok = product.variants.some(function (vt) {
            return vt.available && vt.options.every(function (o, i) {
              return trial[i + 1] == null || trial[i + 1] === o;
            });
          });
          btn.toggleAttribute("disabled", !ok);
        });
      });
    }

    root.addEventListener("click", function (e) {
      var s = e.target.closest(".size");
      if (s) {
        var g = s.closest("[data-option-index]");
        var idx = +g.getAttribute("data-option-index");
        g.querySelectorAll(".size").forEach(function (b) { b.classList.remove("on"); });
        s.classList.add("on");
        selected[idx] = s.getAttribute("data-value");
        refresh();
        return;
      }
      var t = e.target.closest("#thumbs button");
      if (t) {
        root.querySelectorAll("#thumbs button").forEach(function (b) { b.classList.remove("on"); });
        t.classList.add("on");
        setMain(t.getAttribute("data-src"), t.getAttribute("data-fit") || "contain");
        return;
      }
      if (e.target.closest("#atc")) {
        e.preventDefault();
        if (atc.getAttribute("aria-disabled") === "true") return;
        var id = atc.dataset.variant;
        if (!id) return;
        var needs = [];
        optGroups.forEach(function (g) {
          var idx = +g.getAttribute("data-option-index");
          if (selected[idx] == null) needs.push(g);
        });
        if (needs.length) {
          needs[0].scrollIntoView({ block: "center", behavior: reduce ? "auto" : "smooth" });
          needs[0].querySelectorAll(".size").forEach(function (b) {
            b.style.borderColor = "var(--red)";
            setTimeout(function () { b.style.borderColor = ""; }, 900);
          });
          return;
        }
        atc.setAttribute("aria-disabled", "true");
        addToCart(id, 1).catch(function () {}).finally(function () { atc.removeAttribute("aria-disabled"); });
      }
    });

    /* crossfade the main frame between angles */
    var swap = 0;
    function setMain(src, fit) {
      if (!src) return;
      var base = root.querySelector("#pdpMain");
      var over = root.querySelector("#pdpMainB");
      if (!base || !over) return;
      if (reduce) { base.src = src; base.style.objectFit = fit; return; }
      var token = ++swap;
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        if (token !== swap) return;
        over.style.objectFit = fit;
        over.src = src;
        requestAnimationFrame(function () {
          over.classList.add("show");
          setTimeout(function () {
            if (token !== swap) return;
            base.style.objectFit = fit;
            base.src = src;
            over.classList.remove("show");
          }, 300);
        });
      };
      pre.src = src;
    }

    refresh();
  }

  /* ---------- hero settle ---------- */
  var hero = document.querySelector(".hero-media img");
  if (hero && !reduce) {
    var settle = function () { hero.classList.add("settled"); };
    if (hero.complete && hero.naturalWidth) requestAnimationFrame(settle);
    else {
      hero.addEventListener("load", settle, { once: true });
      hero.addEventListener("error", settle, { once: true });
      setTimeout(settle, 1600);
    }
  }

  /* ---------- reveal on scroll ---------- */
  var io = null;
  if (!reduce && "IntersectionObserver" in window) {
    io = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.transitionDelay = (n++ * 60) + "ms";
        e.target.classList.add("in");
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
  }
  function revealAll() {
    document.querySelectorAll(".rv:not(.in)").forEach(function (el) {
      if (io) io.observe(el); else el.classList.add("in");
    });
    failsafe();
  }
  var fsQueued = false;
  function failsafe() {
    if (fsQueued) return;
    fsQueued = true;
    requestAnimationFrame(function () {
      fsQueued = false;
      document.querySelectorAll(".rv:not(.in)").forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < innerHeight * 1.1 && r.bottom > -100) el.classList.add("in");
      });
    });
  }
  addEventListener("scroll", failsafe, { passive: true });
  addEventListener("resize", failsafe, { passive: true });
  revealAll();
  /* Theme editor: new section loaded */
  document.addEventListener("shopify:section:load", revealAll);

  /* ---------- drop clock ---------- */
  var clock = document.getElementById("clock");
  if (clock) {
    var iso = clock.getAttribute("data-deadline");
    var end = iso ? new Date(iso) : null;
    var tick = function () {
      if (!end || isNaN(+end)) { clock.textContent = ""; return; }
      var ms = end - new Date();
      if (ms <= 0) { clock.textContent = "closed"; return; }
      clock.textContent = Math.floor(ms / 864e5) + "d " +
        Math.floor(ms % 864e5 / 36e5) + "h " + Math.floor(ms % 36e5 / 6e4) + "m";
    };
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- boot ---------- */
  getCart().then(renderCart).catch(function () {});
  requestAnimationFrame(function () { document.body.classList.add("ready"); });
})();
